import React, { useState, useEffect } from "react";
import { Form, Input, Button, Select, Checkbox, Row, Col } from "antd";
import API_KEY from "../../../api/index";
const FormItem = Form.Item;
const { Option } = Select;
export default function FormCategory({ categoryId }) {
  const [fieldtype, setFieldtype] = useState(null);
  const [defaults, setDefaults] = useState(null);
  const [isInternal, setIsInternal] = useState(false);
  const [hideDefaults, setHideDefaults] = useState(true);
  const [form] = Form.useForm();

  useEffect(() => {
    if (fieldtype === "csv" || fieldtype === "tags") {
     
      setHideDefaults(false);
    }else{
        setHideDefaults(true);
    }
  }, [fieldtype]);

  const handleFieldType = (value) => {
    console.log(value);
    setFieldtype((state) => value);
  };
  const handleMultipleSelect = (value) => {
    setDefaults((state) => value);
  };
  const handleIsInternal = (e) => {
    setIsInternal(e?.target?.checked);
  };
  const onFinish = (values) => {
    console.log("Success:", values);
    console.log(defaults, "defaults");
    console.log(isInternal, "isInternal");
    API_KEY.URL.patch(`${API_KEY.path.secondaryCategory}/${categoryId}`)
      .then((response) => console.log(response?.data))
      .catch((error) => console.log(error));
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  return (
    <Row>
      <Col span={12}>
        <Form
          {...layout}
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          <FormItem label="Name" name="name">
            <Input placeholder="Enter Name" />
          </FormItem>
          <FormItem label="Field Type" name="dtype">
            <Select onChange={handleFieldType}>
              <Option value="csv">Multiple Select</Option>
              <Option value="text">Text</Option>
              <Option value="textarea">TextArea</Option>
              <Option value="tags">Tags</Option>
            </Select>
          </FormItem>

          <FormItem hidden={hideDefaults} name="default" label="Defaults">
            <Select mode={fieldtype} onChange={handleMultipleSelect}></Select>
          </FormItem>

          <FormItem label="Internal Field" name="dtype">
            <Checkbox onChange={handleIsInternal}>Checkbox</Checkbox>
          </FormItem>

          <FormItem>
            <Button type="primary" htmlType="submit" size="large">
              Submit
            </Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
  );
}
